import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_CLIENT_MANAGER } from '../redux/constants/rolesConstants';
import ClientsHeader from '../components/clients/ClientsHeader';
import ClientsList from '../components/clients/ClientsList';
import ClientsPagination from '../components/clients/ClientsPagination';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';

const Clients = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_CLIENT_MANAGER));
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Клієнти'} />
        </PageTitleContainer>
        <Container>
          <ClientsHeader readOnly={readOnly} />
          <ClientsList readOnly={readOnly} />
          <ClientsPagination />
        </Container>
      </section>
    </Suspense>
  );
};

export default Clients;
